"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InfoLinkAndDescription;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function InfoLinkAndDescription(_ref) {
  var onRequestInformationClick = _ref.onRequestInformationClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'left',
      paddingTop: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: onRequestInformationClick
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "RequestInformation"
  })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "RequestInformationDescription"
  }));
}
InfoLinkAndDescription.propTypes = {
  onRequestInformationClick: _propTypes.default.func.isRequired // Callback defined in parent
};